import store from "@utils/store/cookie";
import localStorage from "@utils/store/localStorage";
import { getUserInfo } from "@api/user";
import dialog from "@utils/dialog";

const state = {
  discus: {
    form: {
      gameInfo: {},
      playerList: [],
      roleTab: 0,
      // 当前的所有卡牌
      cardList: [],
      // 我之前的选择
      frontSelectCardList: [],
      // ==== 初始化卡牌列表 ==== start
      initCardList: [],
      cateId: 0,
      cateName: "",
      secondCateId: 0,
      secondCateName: "",
      // 本轮最多可抽
      extractNum: 1,
      drawNumOptions: [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
      ],
      // ==== 初始化卡牌列表 ==== end
      // 是否同步上一轮
      openSync: 0,
    },
  },
};

const mutations = {
  GAME_DISCUS_FORM(state, val) {
    console.log("GAME_DISCUS_FORM", val);
    state.discus.form = val;
  },
};

const actions = {};

export default {
  state,
  mutations,
  actions,
};
